import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react-lite';
import { useAutoFocus } from './hooks/useAutoFocus';

const searchBoxPillWellStyles = require('./SearchBoxPillWell.scss');
export interface FilePillProps {
    fileName: string;
    isSelected: boolean;
}

export default observer(function FilePill(props: FilePillProps) {
    const pillDiv = useAutoFocus<HTMLDivElement>(props.isSelected);

    return (
        <div className={searchBoxPillWellStyles.filePill} ref={pillDiv} tabIndex={-1}>
            <Icon iconName={ControlIcons.Attach} className={searchBoxPillWellStyles.attachIcon} />
            <div className={searchBoxPillWellStyles.filePillNameText}>{props.fileName}</div>
        </div>
    );
});
